<ng-container *ngIf="type">
  <div class="iframe-container {{type.name}}"
    *ngIf="type.name === 'vimeo' || type.name === 'youtube' || type.name === 'google maps' || type.name === 'soundcloud' || type.name === 'facebook' || type.name === 'generic'">
    <iframe *ngIf="type.name === 'vimeo'" [src]="embedUrl" width="640" height="360" frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture" allowfullscreen loading="lazy" class="vimeo"></iframe>

    <iframe *ngIf="type.name === 'youtube'" width="640" height="360" [src]="embedUrl" frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
      loading="lazy" class="youtube"></iframe>

    <iframe *ngIf="type.name === 'google maps'" [src]="embedUrl" width="640" height="360" style="border:0;"
      allowfullscreen="" loading="lazy" class="google-maps"></iframe>

    <iframe *ngIf="type.name === 'soundcloud'" width="100%" height="300" scrolling="no" frameborder="no"
      allow="autoplay" class="soundcloud" [src]="embedUrl"></iframe>

    <iframe [src]="embedUrl" *ngIf="type.name === 'facebook'" width="500" height="500" class="facebook"
      style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true"
      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>

    <iframe [src]="embedUrl" *ngIf="type.name === 'generic'" class="generic" style="border:none;overflow:hidden"
      scrolling="no" frameborder="0" allowfullscreen></iframe>
  </div>

  <div *ngIf="type.name === 'twitter'">
    <blockquote class="twitter-tweet">
      <a href="https://twitter.com/BBCMOTD/status/{{embedUrl}}"></a>
    </blockquote>
  </div>

  <div *ngIf="type.name === 'instagram'">
    <blockquote class="instagram-media" data-instgrm-captioned [attr.data-instgrm-permalink]="embedUrlString"
      data-instgrm-version="14"
      style="max-width:540px; min-width:326px; padding:0; width:99.375%; width: calc(100% - 2px);">
    </blockquote>
  </div>

</ng-container>
